import { render, staticRenderFns } from "./DefectReportDetails.vue?vue&type=template&id=73f413c0&"
import script from "./DefectReportDetails.vue?vue&type=script&lang=js&"
export * from "./DefectReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports